import { TableRow, TableCell } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const StyledTableRow = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: ${theme.palette.action.lightHover};
  }
`;
export const StyledTableCell = styled(TableCell)`
  border-bottom: none !important;
`;

export const StyledTableCellName = styled(TableCell)`
  border-bottom: none !important;
`;
